import { render, staticRenderFns } from "./ServiceProvidersListView.vue?vue&type=template&id=b077e7b0&"
import script from "./ServiceProvidersListView.vue?vue&type=script&lang=js&"
export * from "./ServiceProvidersListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports